<script>
  import { authStore } from '$lib/stores/authStore';

  async function signIn() {
    try {
      await authStore.login();
    } catch (error) {
      console.error('Sign-in error:', error);
      alert('Sign-in failed. Please try again.');
    }
  }
</script>

<div class="flex h-screen items-center justify-center">
  <button class="variant-filled btn" on:click={signIn}>Sign In</button>
</div>
